<template>
  <svg
    class="icon-plus"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.75 12H20.25"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="cross-icon"
    />
    <path
      d="M12 3.75V20.25"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="cross-icon"
    />
  </svg>
</template>
